import { Button, Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { notificationShow } from 'modules/Notifications/actions'
import styles from 'modules/Services/Network/subcomponents/AccountsList/account-list.module.scss'
import { Link } from 'react-router-dom'

export const RefundButton = ({
  action,
  icon,
  className = '',
  variant = 'ghost',
  extra_info,
  noLabel = true,
  fullWidth = false,
  iconColor = 'inherit',
  link = false,
  ...rest
}) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const hasPendingRefunds = useMemo(
    () =>
      Array.isArray(extra_info) && extra_info.includes('has_pending_refunds'),
    [extra_info],
  )

  const handleClick = useCallback(() => {
    if (!hasPendingRefunds) {
      return
    }
    dispatch(
      notificationShow({
        type: 'error',
        message: t('services::account.notifications.has_pending_refunds.error'),
      }),
    )
  }, [hasPendingRefunds])

  return (
    <Button
      component={hasPendingRefunds ? 'button' : Link}
      size={'s'}
      variant={variant}
      link={link}
      className={className}
      onClick={handleClick}
      startIcon={<Icon name={icon} color={iconColor} />}
      fullWidth={fullWidth}
      additionalIcon={
        !fullWidth && hasPendingRefunds ? (
          <Icon
            className={styles['accounts-list__action-link__additional-icon']}
            name={'status timer'}
            size={'sm'}
          />
        ) : null
      }
      endIcon={
        fullWidth && hasPendingRefunds ? (
          <Icon name={'status timer'} size={'sm'} />
        ) : null
      }
      noLabel={noLabel}
      {...rest}
    >
      {t(`services::account_list.extra_actions.${action}`)}
    </Button>
  )
}

RefundButton.propTypes = {
  action: PropTypes.string,
  id: PropTypes.number,
  login: PropTypes.string,
  icon: PropTypes.string,
  className: PropTypes.string,
  noLabel: PropTypes.bool,
  extra_info: PropTypes.array,
  variant: PropTypes.string,
  fullWidth: PropTypes.bool,
  iconColor: PropTypes.string,
  link: PropTypes.bool,
  url: PropTypes.string,
}
